/** Poll the performance list every 60s — snapshots land at most once per 24h. */
export const PERFORMANCE_POLL_MS = 60_000;

/** Maximum published content rows to fetch for the performance list. */
export const PERFORMANCE_LIST_LIMIT = 200;

/** Top-25% by views = winner (mirrors MVP decision #5 / P75 computation). */
export const WINNER_PERCENTILE = 0.75;
